import BaseContextMenu from '@components/ContextMenu/BaseContextMenu';
import ImageSizeContent, { ImageSizeContentProps } from './ImageSizeContent';

const ImageSizeContextMenu = ({
  value,
  onChangeValue,
  onReset,
  onClose,
}: ImageSizeContentProps) => {
  return (
    <BaseContextMenu onClose={onClose}>
      <ImageSizeContent
        value={value}
        onChangeValue={onChangeValue}
        onReset={onReset}
        onClose={onClose}
      />
    </BaseContextMenu>
  );
};

export default ImageSizeContextMenu;
